<span class="libelle">{{input.data.libelle | translate}}</span>